/**
 * Vantage Core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export type ClaimNoteType = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | 13 | 14;

export const ClaimNoteType = {
  NUMBER_0: 0 as ClaimNoteType,
  NUMBER_1: 1 as ClaimNoteType,
  NUMBER_2: 2 as ClaimNoteType,
  NUMBER_3: 3 as ClaimNoteType,
  NUMBER_4: 4 as ClaimNoteType,
  NUMBER_5: 5 as ClaimNoteType,
  NUMBER_6: 6 as ClaimNoteType,
  NUMBER_7: 7 as ClaimNoteType,
  NUMBER_8: 8 as ClaimNoteType,
  NUMBER_9: 9 as ClaimNoteType,
  NUMBER_10: 10 as ClaimNoteType,
  NUMBER_11: 11 as ClaimNoteType,
  NUMBER_12: 12 as ClaimNoteType,
  NUMBER_13: 13 as ClaimNoteType,
  NUMBER_14: 14 as ClaimNoteType
};
